<template>
  <div
    :class="['right-banner-container',
      $route.name === 'wikiHome' ? 'wiki-home-banner' : '',
      ($route.name === 'wikiList' && scrollY > 168) ? 'fixed-banner' : '',
      ($route.name === 'wikiHome' && scrollY > 118) ? 'fixed-home-banner' : ''
    ]"
    :style="calcBannerStyle"
  >
    <el-popover
      width="406"
      trigger="hover"
      placement="left-start"
      v-if="$route.name !== 'wikiHome' && gameInfo.Config"
    >
      <div class="title-content">
        <div v-if="gameInfo.Config && gameInfo.Config.slogan" class="img-container">
          <img
            :src="handleImgSize(gameInfo.Config.slogan)"
            alt=""
            class="slogan">
        </div>
        <div class="game-detail">
          <div class="desc" v-html="xss(gameInfo.description)"></div>
        </div>
      </div>
      <div slot="reference" class="banner-item">
        <i class="wiki-icon wiki-wiki-gg"></i>
        <span>wiki公告</span>
      </div>
    </el-popover>
    <el-popover
      width="406"
      trigger="hover"
      placement="left-start"
      v-if="linkInfos && linkInfos.module && linkInfos.module.status && linkInfos.list && linkInfos.list.length"
    >
      <div class="link-box">
        <div class="model-title">
          <el-divider>
            <span style="color: #666;font-size: 12px;">排名不分先后</span>
          </el-divider>
        </div>
        <div class="right-model-content" style="padding-bottom:4px;">
          <friend-links :list="linkInfos.list"/>
        </div>
      </div>
      <div slot="reference" v-if="linkInfos && linkInfos.module && linkInfos.module.status && linkInfos.list && linkInfos.list.length" class="banner-item">
        <i class="wiki-icon wiki-wiki-links"></i>
        <span>友情链接</span>
      </div>
    </el-popover>
    <div v-if="$route.name === 'wikiHome'" class="banner-item" @click="handleMessage">
      <i class="wiki-icon wiki-wiki-exchange"></i>
      <span>双屏模式</span>
    </div>
    <div class="banner-item" v-if="$hasPermission('manage')" @click="handleManage">
      <i class="wiki-icon wiki-wiki-manage"></i>
      <span>管理</span>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import friendLinks from '@/views/wiki/components/friendLinks';

export default {
  name: 'rightBanner',
  components: { friendLinks },
  props: {
    gameInfo: {
      type: Object,
      default: () => ({})
    },
    linkInfos: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    calcBannerStyle () {
      const { name } = this.$route;
      return (name === 'wikiGame' || name === 'wikiList') ? {
        marginTop: 0,
      } : name === 'wikiHome' ? {
        marginTop: 0
      } : {};
    }
  },
  data () {
    return {
      scrollY: 0
    }
  },
  methods: {
    handleManage () {
      this.$router.push(`/${this.gameInfo.alias}/admin`);
    },
    handleMessage () {
      const url = `${window.location.origin}/${this.gameInfo.alias}/new`
      window.open(url, '_blank');
    },
    winScroll () {
      this.scrollY = window.document.documentElement.scrollTop || window.document.body.scrollTop;
    }
  },
  mounted () {
    window.addEventListener('scroll',this.winScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll',this.winScroll)
  },
}
</script>
<style lang="less" scoped>
.right-banner-container {
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  top: 0;
  left: 0;
  width: 58px;
  margin-top: 74px;
  // max-height: 212px;
  background-color: #fff;
  border-radius: 8px;
  transform: translateX(-100%);
  &.wiki-home-banner {
    left: -2px;
  }
  &.fixed-banner {
    position: fixed;
    top: 54px;
    // left: 0;
    left: initial;
    right: 50%;
    margin-right: 632px;
  }
  &.fixed-home-banner {
    position: fixed;
    top: 54px;
    // left: 0;
    left: initial;
    right: 50%;
    margin-right: 556px;
  }
  .banner-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 8px 0 15px 0;
    font-size: 28px;
    background-color: #fff;
    // border-radius: 8px;
    border-bottom: 1px solid #EBEBEB;
    cursor: pointer;
    &:last-child {
      border-bottom: none;
    }
    i {
      margin-bottom: 4px;
    }
    span {
      color: #1B1B1B;
      font-size: 12px;
    }
  }
}
.title-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  .img-container {
    padding: 0 20px 30px 20px;
    margin-bottom: 40px;
    border-bottom: 1px solid #E9E9E9;
    img {
      max-width: 184px;
    }
  }
  .game-detail {
    padding: 0 20px;
    padding-bottom: 30px;
    color: #666;
  }
}
.link-box {
  .model-title {
    /deep/ .el-divider--horizontal {
      margin: 17px 0 28px 0;
    }
  }
}
</style>
